import { mapGetters } from 'vuex';
import { isLabelAvailableForConversation } from 'dashboard/helper/labelVisibility';
import userVisibleLabelsMixin from 'dashboard/mixins/labels/userVisibleLabelsMixin';

export default {
  mixins: [userVisibleLabelsMixin],
  computed: {
    ...mapGetters({ accountLabels: 'labels/getLabels' }),
    savedLabels() {
      return this.$store.getters['conversationLabels/getConversationLabels'](
        this.conversationId
      );
    },
    activeLabels() {
      return this.accountLabels.filter(({ title }) =>
        this.savedLabels.includes(title)
      );
    },
    labelConversation() {
      return (
        this.$store.getters.getConversationById(this.conversationId) ||
        this.$store.getters.getSelectedChat
      );
    },
    // Vinculados continuam visíveis; novos só se compatíveis com o escopo.
    availableLabels() {
      return this.accountLabels.filter(
        label =>
          this.savedLabels.includes(label.title) ||
          isLabelAvailableForConversation(
            label,
            this.labelConversation,
            this.labelUserContext
          )
      );
    },
    inactiveLabels() {
      return this.availableLabels.filter(
        ({ title }) => !this.savedLabels.includes(title)
      );
    },
  },
  methods: {
    addLabelToConversation(value) {
      const result = this.activeLabels.map(item => item.title);
      result.push(value.title);
      this.onUpdateLabels(result);
    },
    removeLabelFromConversation(value) {
      const result = this.activeLabels
        .map(label => label.title)
        .filter(label => label !== value);
      this.onUpdateLabels(result);
    },
    async onUpdateLabels(selectedLabels) {
      this.$store.dispatch('conversationLabels/update', {
        conversationId: this.conversationId,
        labels: selectedLabels,
      });
    },
  },
};
